import gql from 'graphql-tag'

export const ADD_CAPITAL_INCREASE = gql`
  mutation addCapitalIncrease($input: AddCapitalIncreaseInput!) {
    addCapitalIncrease(input: $input)
  }
`;
